export default __webpack_public_path__ + "static/media/img_selected-industry-smart-workplace.fb697bfa.svg";